import {Promotion} from "./promotion"
export class SimplePromotion {
   constructor(id, name, description = null){
      this.id = id
      this.name = name
      this.description = description
   }

   /**
    * 
    * @param {Promotion} promotion 
    */
   static fromPromotion(promotion){
      return new SimplePromotion(
         promotion.id,
         promotion.name,
      );
   }

   /**
    * 
    * @param {SimplePromotion} to 
    * @param {SimplePromotion} from 
    */
   static copyData(to, from){
      to.id = from.id
      to.name = from.name
      to.description = from.description
   }
}